export default __webpack_public_path__ + "img/chevron-down-grey.811df8b6.svg";